// DocsProvider.js
import { useState, useEffect } from "react";
import { DocsContext } from "./Context";
import { useParams, useSearchParams } from "react-router-dom";
import api from "../../api/axios";

export const DocsProvider = ({ children }) => {
  const [searchParams] = useSearchParams();
  const caseId = searchParams.get("id");
  const [docsInfo, setDocsInfo] = useState({});
  const [docsInfoTransfered, setDocsInfoTransfered] = useState({});
  const [docsFlag, setDocsFlag] = useState(false);
  const [docFlagTransfered, setDocFlagTransfered] = useState(false);
  const [docsChangedFlag, setDocsChangedFlag] = useState(false);

  const getDocsInfo = async (case_id = 0) => {
    // console.log(case_id);
    try {
      setDocsFlag(false);
      setDocFlagTransfered(false);
      const { data } = await api.post(
        `${process.env.REACT_APP_API_URL}/s3/show/${
          case_id ? case_id : caseId
        }`,
        {}
      );

      const groupedByCase = getGroupedCase(data?.files);
      // console.log(groupedByCase);

      if (data?.mergedFilesTransfered) {
        const groupedByTransferedCases = getGroupedCase(
          data?.mergedFilesTransfered
        );

        if (Object.keys(groupedByTransferedCases).length === 0) {
          setDocFlagTransfered(false);
        } else {
          setDocFlagTransfered(true);
        }
        // console.log(groupedByTransferedCases);

        setDocsInfoTransfered(groupedByTransferedCases);
      }

      // console.log(Object.keys(groupedByCase).length === 0);

      if (Object.keys(groupedByCase).length === 0) {
        setDocsFlag(false);
      } else {
        setDocsFlag(true);
      }

      setDocsInfo(groupedByCase);
    } catch (error) {
      console.error("Error cargando documentos:", error);
      setDocsFlag(true);
      setDocFlagTransfered(true);
    }
  };

  const getGroupedCase = (data) => {
    const enrichedFiles = data || [];

    const groupedByCase = enrichedFiles.reduce((acc, file) => {
      const parts = file.path.split("/");
      const caseId = /^\d+$/.test(parts[1]) ? parts[1] : "sin_carpeta";
      const subFolder = parts.length >= 4 ? parts[2] : "Sin Carpeta";

      if (!acc[caseId]) acc[caseId] = {};
      if (!acc[caseId][subFolder]) acc[caseId][subFolder] = [];

      acc[caseId][subFolder].push(file);
      return acc;
    }, {});

    for (const caseId in groupedByCase) {
      for (const subFolder in groupedByCase[caseId]) {
        groupedByCase[caseId][subFolder].sort((a, b) =>
          a.file_name.localeCompare(b.file_name)
        );
      }
    }

    return groupedByCase;
  };

  useEffect(() => {
    // console.log(caseId);
    if (caseId) {
      getDocsInfo(caseId);
    }
  }, [caseId, docsChangedFlag]);

  return (
    <DocsContext.Provider
      value={{
        docsInfo,
        docsChangedFlag,
        setDocsChangedFlag,
        getDocsInfo,
        docsInfoTransfered,
        docFlagTransfered,
        docsFlag,
      }}>
      {children}
    </DocsContext.Provider>
  );
};
